export enum RetentionUnit {
    Days = "Days",
    Items = "Items"
}

export interface RetentionPeriod {
    QuantityToKeep: number;
    ShouldKeepForever: boolean;
    Unit: RetentionUnit;
}

export default RetentionPeriod;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/retentionPeriod.ts